import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function NewRowCell({ cell, row, column, updateData }) {
  const newlyAdded = nullCheck(cell, "", "row", "original", "newlyAdded");

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", height: "20px" }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {newlyAdded &&
        <CircleIcon
          sx={{ fontSize: "10px", color: "success.60", cursor: "pointer" }}
          onClick={() => updateData(row.index, column.id, false)}
        />
      }
    </Box>
  );
}

NewRowCell.propTypes = {
  cell: PropTypes.object,
  row: PropTypes.object,
  column: PropTypes.object,
  updateData: PropTypes.func
};